export default function StickyMenu(selector = ".header-area") {
  document.addEventListener("scroll", () => {
    const element = document.querySelector(selector);
    if (element) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        element.classList.add("scroll-header");
      } else {
        element.classList.remove("scroll-header");
      }
    }
  });
}
